const config = {
    list: [
        {
            label: '仓库编码',
            value: '',
            prop: 'whCode',
            type: 'input',
            disabledInSub: true,
        },
        {
            label: '仓库名称',
            value: '',
            prop: 'whName',
            type: 'input',
            disabled: false,
            mustFillInSub: true,
            max: 20,
        },
        {
            label: '仓库地址',
            value: 'eblcDetailAddress',
            prop: 'whAddress',
            type: 'advance',
            name: '仓库地址',
            unfold: true,
            advanceConfig: [
                { prop: 'eblcNameCn', value: '中文名称' },
                { prop: 'eblcDetailAddress', value: '详细地址' },
                { prop: 'eblcCode', value: '地点代码' },
            ],
            tableConfig: [
                { prop: 'eblcCode', value: '地点代码' },
                { prop: 'eblcNameCn', value: '中文名称' },
                { prop: 'eblcDetailAddress', value: '详细地址' },
            ],
            advanceUrl: '/ebLocations?',
            cbParams: [
                'eblcCode#eblcCode',
                'eblcDetailAddress#eblcDetailAddress',
                'eblcNameCn#eblcNameCn',
                'eblcProvinceName#provinceName',
                'eblcProvinceCode#provinceCode',
                'eblcCountyName#districtName',
                'eblcCountyCode#districtCode',
                'eblcTownName#townName',
                'eblcTownCode#townCode',
            ],
            disabled: false,
            mustFillInSub: true,
            disabledInSub: true,
        },
        {
            label: '仓库建筑面积（㎡）',
            value: '',
            prop: 'whSquare',
            type: 'input',
            disabled: false,
            mustFillInSub: true,
            isPositiveNum: true,
        },
        // 加权的表单类型weightedInput
        {
            label: '实用面积(m²)',
            value: '',
            prop: 'usableArea',
            type: 'weightedInput',
            isPositiveNum: true,
            disabledInSub: true,
            info: '消防分区面积之和',
        },
        {
            label: '合同状态',
            value: '',
            prop: 'contractStatus',
            type: 'mSelect',
            optionNum: 'PHY_WH_CONTRACT_STATUS',
            mustFillInSub: true,
            disabledInSub: true,
        },
        {
            label: '墙上标识图片',
            value: '',
            prop: 'wallSignImg',
            type: 'upload',
            mustFillInSub: true,
        },
        {
            label: '单体仓规划图',
            value: '',
            prop: 'entityPlanImg',
            type: 'upload',
            mustFillInSub: true,
        },
        {
            label: '产权属性',
            value: '',
            prop: 'propertyType',
            type: 'mSelect',
            optionNum: 'SYS_PROPERTY_RIGHTS',
            disabled: false,
        },
        {
            label: '产权人',
            value: '',
            prop: 'propertyOwner',
            type: 'input',
            disabled: false,
            max: 20,
        },
        {
            label: '管理属性',
            value: '',
            prop: 'manageType',
            type: 'mSelect',
            optionNum: 'SRM_WH_MANAGE_ATTRIBUTES',
            disabled: false,
        },
        {
            label: '仓库类型',
            prop: 'whType',
            value: '',
            type: 'mSelect',
            optionNum: 'SYS_SU_WH_TYPE',
            disabled: false,
        },
        {
            label: '备用发电机',
            value: '',
            prop: 'poweredSystemFlag',
            type: 'mSelect',
            optionNum: 'SRM_WH_POWER_SYSTEM',
            disabled: false,
        },
        {
            label: '净高（M）',
            value: '',
            prop: 'whHeight',
            type: 'input',
            disabled: false,
            isPositiveNum: true,
        },
        {
            label: '消防验收',
            value: '',
            prop: 'fireInspection',
            optionNum: 'SYS_SU_FIRE_INSPECTION',
            type: 'mSelect',
            disabled: false,
        },
        {
            label: '消防设施',
            value: '',
            prop: 'fireFacilities',
            optionNum: 'SYS_SU_FIRE_FACILITIES',
            type: 'mSelect',
            disabled: false,
        },
        // {
        //     label: '消防单元面积（㎡）',
        //     value: '',
        //     prop: 'fireUnitArea',
        //     type: 'input',
        //     disabled: false,
        //     isPositiveNum: true,
        // },
        {
            label: '月台',
            value: '',
            prop: 'platform',
            type: 'mSelect',
            optionNum: 'SYS_SU_PLATFORM',
            disabled: false,
        },
        {
            label: '雨棚',
            value: '',
            prop: 'canopy',
            optionNum: 'SYS_SU_CANOPY',
            type: 'mSelect',
            disabled: false,
        },
        {
            label: '地面承压',
            value: '',
            prop: 'pressure',
            optionNum: 'SYS_SU_PRESSURE',
            type: 'mSelect',
            disabled: false,
        },
        {
            label: '建筑结构',
            value: '',
            prop: 'buildingType',
            optionNum: 'SYS_SU_BUILDING_TYPE',
            type: 'mSelect',
            disabled: false,
        },
        {
            label: '园区通道',
            value: '',
            prop: 'parkPath',
            optionNum: 'SYS_SU_PARK_PATH',
            type: 'mSelect',
            disabled: false,
        },
        // {
        //     label: '采光带占比',
        //     value: '',
        //     prop: 'withLighting',
        //     type: 'mSelect',
        //     optionNum: 'SYS_SU_WITH_LIGHTING',
        //     disabled: false,
        // },
        {
            label: '距市区距离（km）',
            value: '',
            prop: 'cityDistance',
            type: 'input',
            disabled: false,
            isPositiveNum: true,
        },
        {
            label: '照明系统',
            value: '',
            prop: 'lightingSystem',
            optionNum: 'SYS_SU_LIGHTING_SYSTEM',
            type: 'mSelect',
            disabled: false,
        },
        {
            label: '办公室',
            value: '',
            prop: 'officeFlag',
            type: 'mSelect',
            optionNum: 'SRM_WH_OFFICE',
            disabled: false,
        },
        {
            label: '分公司',
            value: 'companyNameCn',
            prop: 'companyName',
            type: 'weightedInput',
            // type: 'advance',
            // name: '分公司',
            // unfold: true,
            // advanceConfig: [
            //     { prop: 'companyNameCn', value: '分公司名称' },
            //     { prop: 'companyCode', value: '分公司编码' },
            // ],
            // tableConfig: [
            //     { prop: 'companyCode', value: '分公司编码' },
            //     { prop: 'companyNameCn', value: '分公司名称' },
            // ],
            // advanceUrl: '/esCompany/popCompany',
            // cbParams: ['companyCode#companyCode', 'companyNameCn#companyNameCn'],
            // disabled: true,
            // editable: false,
            disabledInSub:true,
        },
        {
            label: '城市',
            value: 'ebplNameCn',
            prop: 'cityName',
            type: 'advance',
            name: '城市',
            unfold: true,
            advanceConfig: [
                { prop: 'ebplNameCn', value: '中文名称' },
                { prop: 'ebplCode', value: '代码' },
            ],
            tableConfig: [
                { prop: 'ebplCode', value: '代码' },
                { prop: 'ebplNameCn', value: '中文名称' },
                { prop: 'ebplNameEn', value: '英文名称' },
            ],
            advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY&ebplIsAble=ENABLE',
            cbParams: ['ebplCode#ebplCode', 'ebplNameCn#ebplNameCn'],
            disabled: false,
        },
        {
            label: '单价(元/平方米)',
            value: '',
            prop: 'unitPrice',
            type: 'weightedInput',
            isPositiveNum: true,
        },
        {
            label: '联系人',
            value: '',
            prop: 'contacts',
            type: 'weightedInput',
            max: 20,
        },
        {
            label: '联系电话',
            value: '',
            prop: 'contactsPhone',
            type: 'weightedInput',
        },
        {
            label: '修改人',
            prop: 'updateUserName',
        },
        {
            label: '修改时间',
            prop: 'updateTime',
        },
    ],
}

export default config
